export default (param) => {
    throw (new Error(`Missing parameter: ${param}`));
};